import React from 'react'
import actions from 'redux/actions'
import { useMedia, useCallback } from 'sb-hooks'
import { constants } from 'common/helpers'

import ModalContainer from 'components/_new/modal/ModalContainer/ModalContainer'
import Modal from 'components/_new/modal/Modal/Modal'
import MobileModal from 'components/_new/modal/MobileModal/MobileModal'
import Overlay from 'components/_new/layout/Overlay/Overlay'
import Headline from 'components/_new/typography/deprecated/Headline/Headline'
import Button from 'components/_new/Button/Button'
import ButtonsInRow from 'components/_new/buttons/ButtonsInRow/ButtonsInRow'
import Box from 'components/_new/layout/Box/Box'

import Picture from 'components/ui/Picture/Picture'

import s from './FeedbackSuccessModal.scss'
import messages from './messages'

// resolve picture x2
import successImg from './images/success.png'


const close = () => actions.models.modals.close(constants.modals.humble.FeedbackFormSuccess)

const FeedbackSuccessModal = ({ data: { title, text, alignCenter, brandButtonProps = {}, textButtonProps = {} } }) => {
  const { isMobile } = useMedia()

  const titleMessage = title || messages.title
  const textMessage = text || messages.text

  const handleBrandButtonClick = useCallback(() => {
    close()

    if (typeof brandButtonProps.onClick === 'function') {
      brandButtonProps.onClick()
    }
  }, [ brandButtonProps ])

  const handleTextButtonClick = useCallback(() => {
    close()

    if (typeof textButtonProps.onClick === 'function') {
      textButtonProps.onClick()
    }
  }, [ textButtonProps ])

  const buttonsNode = (
    <ButtonsInRow alignLeft={!alignCenter}>
      {
        Boolean(textButtonProps.title) && (
          <Button
            className={s.button}
            size="md"
            title={textButtonProps.title}
            onClick={handleTextButtonClick}
          />
        )
      }
      <Button
        className={s.button}
        size="md"
        color="brand"
        title={brandButtonProps.title || messages.ok}
        onClick={handleBrandButtonClick}
      />
    </ButtonsInRow>
  )

  return isMobile ? (
    <MobileModal onBackdropClick={close}>
      <Box alignCenter>
        <Picture className={s.bird} {...successImg} />
        <Headline title={titleMessage} subTitle={textMessage} size="lg" mutedSubTitle={false} />
        {buttonsNode}
      </Box>
    </MobileModal>
  ) : (
    <ModalContainer>
      <Overlay onClick={close} />
      <Modal onClose={close} footerNode={buttonsNode}>
        <Box alignCenter={alignCenter}>
          <Picture className={s.bird} {...successImg} />
          <Headline title={titleMessage} subTitle={textMessage} size="lg" mutedSubTitle={false} />
        </Box>
      </Modal>
    </ModalContainer>
  )
}


export default FeedbackSuccessModal
